// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

import { ACCOUNT_API_URL } from '../js/nx-environment-variables';

export const environment = {
    production: false,
    enableErrorBoundary: true,
    accountApiUrl: 'https://admiral-fips.dev.yadkrow.com',
    enableLogging: true, // Main toggle for all logging
    enableLogs: true, // Toggles error logs & message logs
    enableSessionStats: true, // Toggles session stats logs
    enableReduxLogger: false
};
